import { makeStyles, createStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) =>
  createStyles({
    header: {
      color: theme.palette.primary.main,
      fontWeight: "bold",
    },
    form: {
      display: "flex",
      flexDirection: "column",
      flexWrap: "wrap",
    },
    margin: {
      marginTop: "1.4rem",
    },
    subForm: {
      display: "flex",
      justifyContent: "space-between",
    },
    switch: {
      color: "#0000008A",
    },
    footer: {
      marginTop: "1.2rem",
    },
    footerItem: {
      marginTop: "2rem",
    },
  })
);

export default useStyles;
